import BaseModule from '../../../javascripts/helpers/baseModule';
import addClass from '../../../javascripts/dom/addClass';
import removeClass from '../../../javascripts/dom/removeClass';
import triggerCustomEvent from '../../../javascripts/events/triggerCustom';

const isPlayingModifier = 'video--is-playing';
const hasPosterModifier = 'video--has-poster';

const players = {
  file: '<video class="video__player" src="{{path}}" {{autoplay}} controls></video>',
  youtube:
    '<iframe class="video__iframe" type="text/html" src="//www.youtube.com/embed/{{path}}?rel=0&autoplay={{autoplay}}" allowfullscreen frameborder="0"/>',
  vimeo:
    '<iframe class="video__iframe" type="text/html" src="//player.vimeo.com/video/{{path}}?autoplay={{autoplay}}&title=0&byline=0&portrait=0" allowfullscreen frameborder="0"/>'
};

// hack to show first frame as poster on iphone/ipad: make it autoplay
const agent = navigator.userAgent;
if (agent.indexOf('iPhone') !== -1 || agent.indexOf('iPod') !== -1) {
  players.file =
    '<video class="video__player" src="{{path}}" autoplay controls></video>';
}

export default class Video extends BaseModule {
  constructor(element) {
    super(element, element.getAttribute('data-js-module'));

    this.getElements([
      { id: 'button', selector: 'button' },
      { id: 'container', selector: 'embed-container' }
    ]);

    if (this.hasPoster()) {
      this.bindCLickEvent();
    } else {
      this.embedVideo(0);
    }
  }

  bindCLickEvent() {
    this.elements.button.addEventListener('click', (event) => {
      event.preventDefault();

      triggerCustomEvent(window, 'Videos.stopAllVideos');
      window.addEventListener('Videos.stopAllVideos', (e) => {
        this.stopVideo();
      });

      window.addEventListener('Videos.toggleConsentWindow', () => {
        triggerCustomEvent(
          window,
          'CookieConsent.toggle',
          this.elements.self.dataset.jsSource
        );
      });

      window.addEventListener('CookieConsent.onPermissionChange', (e) => {
        if (
          this.elements.self.dataset.jsSource === e.detail.service.name &&
          e.detail.consent === true
        ) {
          removeClass(this.elements.self, 'cookie-consent-permission-missing');
          this.embedVideo(1);
        }
      });

      this.embedVideo(1);

      addClass(this.elements.self, isPlayingModifier);
    });
  }

  embedVideo(autoplay = 0) {
    let video = '';
    const source = this.elements.self.dataset.jsSource;

    if (source === 'file') {
      video = players[source]
        .replace(/{{path}}/, this.elements.self.dataset.jsPath)
        .replace(/{{autoplay}}/, autoplay ? 'autoplay' : '');
    } else if (window.cookieConsentKlaro) {
      if (window.cookieConsentKlaro[source] === true) {
        video = players[source]
          .replace(/{{path}}/, this.elements.self.dataset.jsPath)
          .replace(/{{autoplay}}/, autoplay);
      } else {
        triggerCustomEvent(window, 'CookieConsentKlaro.toggle', source);
        addClass(this.elements.self, 'cookie-consent-permission-missing');
      }
    } else {
      video = players[source]
        .replace(/{{path}}/, this.elements.self.dataset.jsPath)
        .replace(/{{autoplay}}/, autoplay);
    }

    this.elements.container.innerHTML = video;
  }

  stopVideo() {
    while (this.elements.container.firstChild) {
      this.elements.container.removeChild(this.elements.container.firstChild);
    }
    removeClass(this.elements.self, isPlayingModifier);
  }

  hasPoster() {
    return this.elements.self.classList.contains(hasPosterModifier);
  }
}
